import React, { useState } from 'react'
import "./Footer.css"
import bell from "../../assets/bell 1.svg"
import arrow from '../../assets/arrow.svg'
import PopupAlert from '../PopupAlert/PopupAlert'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const {i18n,t}=useTranslation();
  const [showApartments, setShowApartments] = useState(false);
  const [showUsefulLinks, setShowUsefulLinks] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  
  const searchParamsMurgon = new URLSearchParams();
  searchParamsMurgon.append("city", "Mugron");
  
  const searchParamsDax = new URLSearchParams();
  searchParamsDax.append("city", "Dax");

 

  const toggleApartments = () => {
    setShowApartments(!showApartments);
  };
  const toggleUsefulLinks = () => {
    setShowUsefulLinks(!showUsefulLinks);
  };
  const openPopup = () => {
    setIsPopupOpen(true);
  };
  const closePopup = () => {
    setIsPopupOpen(false);
  };
  const [rotateDegree, setRotateDegree] = useState(90);
  const [rotateDegree1, setRotateDegree1] = useState(90);
  const toggleRotation = () => {
    setRotateDegree((prevDegree) => (prevDegree === 90 ? 270 : 90));
  };
  const toggleRotation1 = () => {
    setRotateDegree1((prevDegree) => (prevDegree === 90 ? 270 : 90));
  };
  const handleClick = () => {

    toggleApartments();
    toggleRotation();
  };
  const handleClick1 = () => {
    toggleUsefulLinks();
    toggleRotation1();
  };
  const language = i18n.language
  let termsUrl='/page/fr-cgu'
  
  if (language === 'en') {
    termsUrl = '/page/en-cgu';
  } else if (language === 'es') {
    termsUrl = '/page/es-cgu';
  }

  let legalUrl='/page/fr-mentions-legales'
  
  if (language === 'en') {
    legalUrl = '/page/en-legal-notices';
  } else if (language === 'es') {
    legalUrl = '/page/es-aviso-legal';
  }

  return (
    <>
      <div className='Footer-container mb-4 pb-3 pt-3 mt-5'>
        <div className='container'>
          <div className="row justify-content-between align-items-center">
            <div className='Apartements'>
              <p className='h3'>{t("footer.apartments")}</p>
              <div className='d-flex justify-content-start align-items-start gap-4'>
                <div className='First'>
                  <p><a href={`/${language}/search-cities?${searchParamsMurgon.toString()}`}>{t("footer.mugron")}</a></p>
                  <p><a href={`/${language}/search-cities?${searchParamsDax.toString()}`}>{t("footer.dax")}</a></p>
                 
                </div>
                <div className='Second'>
                <p><a href={`/${language}/search-cities`}>{t("footer.all")}</a></p>
                  
                </div>
              </div>
            </div>
            <div className='Useful-links px-3'>
              <p className='h3'>{t("footer.links")}</p>
              <div className='d-flex justify-content-between align-items-center gap-3'>
                <div className='First'>
                  <p><a href={`/${language}/faq`}>FAQ</a></p>
                  <p><a href={`/${language}/contact`}>{t("footer.contact")}</a></p>
                </div>
                <div className='Second'>
                  <p><a href={termsUrl}>{t("footer.cgu")}</a></p>
                  <p><a href={legalUrl}>{t("footer.ml")}</a></p>
                </div>
              </div>
            </div>
            <div className='Create-alert px-3' id='create_alert'>
              <p className='h3'>{t("footer.question")} </p>
              <button className='btn btn-alert' onClick={openPopup}>
                <img src={bell} alt='bell' />{t("footer.alert")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile collapse */}
      <div className='Footer-container-mobile'>
        {/* Apartments Section */}
        <div className='Apartements container'>
          <div className='d-flex justify-content-between align-items-center'>
            <p className='h3'>{t("footer.apartments")}</p>
            <img src={arrow} alt='arrow' style={{ transform: `rotate(${rotateDegree}deg)` }} onClick={handleClick} />
          </div>
          {/* Footer Content */}
          {showApartments && (
            <div className='Footer-content'>
              {/* Apartments content */}
              <div className='Footer-content'>
                <div className='First'>
                <p><a href={`/${language}/search-cities?${searchParamsMurgon.toString()}`}>{t("footer.mugron")}</a></p>
                <p><a href={`/${language}/search-cities?${searchParamsDax.toString()}`}>{t("footer.dax")}</a></p>
                  
                </div>
                <div className='Second'>
                 <p><a href={`/${language}/search-cities`}>{t("footer.all")}</a></p>
                
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Useful Links Section */}
        <div className='Useful-links container'>
          <div className='d-flex justify-content-between align-items-center'>
            <p className='h3'>{t("footer.links")}</p>
            <img src={arrow} alt='arrow' style={{ transform: `rotate(${rotateDegree1}deg)` }} onClick={handleClick1} />
          </div>
          {/* Footer Content */}
          {showUsefulLinks && (
            <div className='Footer-content'>
              {/* Useful links content */}
              <div className='Useful-links'>
                <div className=''>
                  <div className='First'>
                    <p><a href={`/${language}/faq`}>FAQ</a></p>
                    <p><a href={`/${language}/contact`}>{t("footer.contact")}</a></p>
                  </div>
                  <div className='Second'>
                    <p><a href={termsUrl}>{t("footer.cgu")}</a></p>
                    <p><a href={legalUrl}>{t("footer.ml")}</a></p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Create Alert Section */}
        <div className='Create-alert container' id='create_alert'>
          <p className='h3'>{t("footer.question")} </p>
          <button className='btn btn-alert' onClick={openPopup}>
            <img src={bell} alt='bell' />{t("footer.alert")}
          </button>
        </div>
      </div>
      {/* Horizontal Line and Copyright */}
      <div className='Copyright'>
        <p className='m-0 text-center'>Copyright © {new Date().getFullYear()}. {t("footer.copyright")} <a href='https://oxton-digital.com/' target='_blank' rel='noopener noreferrer'>Oxton Digital.</a></p>
      </div>
      {/* PopupAlert */}
      <PopupAlert isPopupOpen={isPopupOpen} onClose={closePopup} id="popupAlert1" />
    </>
  );
};

export default Footer;